import React, { Component } from 'react';
import * as firebase from 'firebase';

import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import Snackbar from 'material-ui/Snackbar';

import Header from '../Header/Header';
import {
  Container,
  FormContainer,
  FormGroup,
  FormTitle,
  Pre,
  Code
} from '../Styles/index';

class EditorComp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      questions: [],
      question: '',
      answer: '',
      openSnackBar: false,
      hasError: false,
      error: {}
    }
  }

  _handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  _handleRequestClose = () => {
    this.setState({
      openSnackBar: false,
    });
  };

  _handleDelete = (key) => {
    firebase.database().ref().child('help_questions').child(key).remove();
  }

  _handleSubmit = (event) => {
    event.preventDefault();
    firebase.database().ref().child('help_questions').push({
      question: this.state.question,
      answer: this.state.answer
    }, error => {
      if (error) {
        this.setState({
          hasError: true,
          error: error 
        });
        return;
      }
      this.setState({
        hasError: false,
        error: {}, 
        openSnackBar: true,
        question: '',
        answer: ''
      })
    })
  }

  componentWillMount() {
    firebase.database().ref().child('help_questions').on('value', snapshot => {
      const questionList = [];
      snapshot.forEach(q => {
        questionList.push({ ...q.val(), key: q.key });
      })

      this.setState({
        questions:  questionList
      });
    })
  }

  render(){
    return (
      <div>
        <Header />
        <form onSubmit={this._handleSubmit}>
          <Container>
            <FormContainer >
              <FormGroup>
                <FormTitle>Add question</FormTitle>
              </FormGroup>
              <div>
                <TextField
                  fullWidth
                  required
                  id="question"
                  name="question"
                  floatingLabelText="Question?"
                  value={this.state.question}
                  onChange={this._handleChange}
                />
              </div>
              <div>
                <TextField
                  fullWidth
                  required
                  id="answer"
                  name="answer"
                  multiLine={true}
                  rows={4}
                  floatingLabelText="Answer"
                  value={this.state.answer}
                  onChange={this._handleChange}
                />
              </div>
              
              <FormGroup >
                <RaisedButton type='submit' label="Update" primary={true} />
              </FormGroup>
              <Snackbar
                open={this.state.openSnackBar}
                message="Help question added succesfully!"
                autoHideDuration={3000}
                onRequestClose={this._handleRequestClose}
              />
              {this.state.hasError &&
                <FormGroup>
                  <Pre>
                    <Code>
                      {`${JSON.stringify(this.state.error, undefined, 2)}`}
                    </Code>
                  </Pre>
                </FormGroup>
              }
            </FormContainer>
          </Container>
        </form>
        <div style={{ maxWidth: 600, margin: '0 auto'}}>
          <FormGroup>
            <FormTitle>Help Questions</FormTitle>
          </FormGroup>
          {this.state.questions.map(q => 
            <Card key={q.key} style={{ marginBottom: 16 }}>
              <CardHeader
                titleStyle={{ fontWeight: '600' }}
                title={q.question}
              />
              <CardText>
                {q.answer}
              </CardText>
              <CardActions style={{ textAlign: 'right' }}>
                <RaisedButton 
                  label="Delete" 
                  labelStyle={{height: 'auto', color: 'white'}} 
                  backgroundColor="#F44336" 
                  onTouchTap={event => this._handleDelete(q.key)} 
                />
              </CardActions>
            </Card>
          )}
        </div>
      </div>
    )
  }
}


export default EditorComp;



// WEBPACK FOOTER //
// ./src/components/Help/Editor.js